import { render, staticRenderFns } from "./InputMaskTabRow.vue?vue&type=template&id=28a85218&"
import script from "./InputMaskTabRow.vue?vue&type=script&lang=js&"
export * from "./InputMaskTabRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports